module.exports = __webpack_public_path__ + "img/HD_hd_logo_1_60e10354c.png";